<template>
    <!-- Configurator -->
    <transition name="fade">
        <fa
            :icon="['fad', 'spinner-third']"
            class="text-dgreen opacity-50 fa-spin mx-auto w-8 h-8 absolute right-8 top-8"
            v-if="data.loading"
        />
    </transition>

    <!-- Padlocks or Rimlocks -------------------------------------------->
    <!-- TODO: Rewrite this compontents and show when needed -->

    <step
        :step="steps.locks"
        title="Opleg- of hangsloten"
        :active="false"
        :done="true"
        v-if="predefined.rimlock || predefined.padlock"
    >
        <template v-slot:description>
            <span>Kies hier jouw hang- of oplegslot.</span>
        </template>

        <template v-slot:option>
            <Locks
                :form="form"
                :product="product"
                :options="options"
                :clean="true"
                :smartlocks="form.cylindersValid && !disableCylinders"
                @showModalSmartlock="showModalSmartlock(false)"
            >
            </Locks>
        </template>
    </step>

    <!-- Aantal cilinders -->
    <step
        :step="steps.cylinderQty"
        title="Aantal gelijksluitende cilinders"
        description="Kies hier het totaal aantal cilinders. Binnen deze set zijn alle cilinders met dezelfde sleutel te openen."
        :active="!form.qtySelected && !disableCylinders"
        :done="form.qtySelected && !disableCylinders"
        :error="$page.props.errors.qtySelected"
        v-if="form.cylinders.length || disableCylinders || !inBrowser"
    >
        <template v-slot:option>
            <CylinderQty
                v-if="!disableCylinders"
                v-model:qty="data.cylinderQty"
                v-model:sliceIndex="data.sliceIndex"
                v-model:cylinderCopy="data.cylinderCopy"
                v-model:isSelected="form.qtySelected"
                v-model:cylinders="form.cylinders"
            />
        </template>

        <template v-slot:top>
            <SwitchGroup
                as="div"
                class="flex items-center mt-4 w-full bottom-5 rounded-xl p-0"
                v-if="(predefined.padlock || predefined.rimlock) && (form.padlocks.length || form.rimlocks.length)"
            >
                <Switch v-model="disableCylinders" :class="[disableCylinders ? 'bg-dgreen' : 'bg-gray-200', 'switch']">
                    <span aria-hidden="true" :class="[disableCylinders ? 'translate-x-5' : 'translate-x-0']" />
                </Switch>
                <SwitchLabel as="span" class="ml-3">
                    <span class="switch-label">Geen cilinders meebestellen</span>
                </SwitchLabel>
            </SwitchGroup>
        </template>
    </step>

    <!-- Cylinder configuration -------------------------------------------->
    <step
        :step="steps.cylinderSize"
        title="Maten en opties"
        :active="form.qtySelected && !form.cylindersValid && !disableCylinders"
        :done="form.cylindersValid && !disableCylinders"
        v-if="form.cylinders.length || disableCylinders || !inBrowser"
    >
        <template v-slot:description>
            <span
                >Staat jouw cilinderslot maat er niet tussen? Kies dan de dichtstbijzijnde maat. De cilinder mag
                maximaal 3 mm buiten de deur steken.</span
            ><span v-if="product.brand_id == 1 && !product.reorder">
                Deze cilinder is standaard <strong>met paniekfunctie</strong>.
            </span>
        </template>
        <template v-slot:option>
            <cylinders
                :product="product"
                :form="form"
                :data="data"
                :options="options"
                :text_blocks="text_blocks"
                :sizesB="sizesB"
                @showModalSmartlock="showModalSmartlock"
                v-if="(form.qtySelected && !disableCylinders)"
            ></cylinders>

            <!-- Old Add button -->
            <AdviceWide class="mt-6 hidden xl:block" v-if="form.keys.customColors" />
            <AdviceWide class="mt-6 block xl:hidden" />
        </template>
    </step>

    <!-- Sleutels -->
    <step
        :step="steps.keys"
        title="Sleutels"
        :active="
            ((form.cylindersValid && !form.keysSelected) || (product.reorder_type == 2 && !form.keysSelected)) &&
            !shouldDisableKeyOption
        "
        :done="form.keysSelected || shouldDisableKeyOption"
        :error="$page.props.errors.keysSelected"
        :disabled="shouldDisableKeyOption"
    >
        <template v-slot:description>
            <div class="text-gray-600">
                <div v-if="shouldDisableKeyOption" class="mt-8">
                    Bij deze combinatie worden er geen sleutels meegeleverd.
                </div>
                <div v-else-if="product.reorder_type == 2">Kies het aantal gewenste sleutels om na te bestellen.</div>
                <div v-else-if="product.reorder_type == 1 && product.brand_id == 1">
                    Standaard worden er geen sleutels bijgeleverd.
                </div>
                <div v-else>
                    Standaard
                    <strong class="text-gray-800">{{ data.totals.default_key_qty }} gratis sleutels</strong>
                    bij
                    <strong class="text-gray-800"
                        >{{ form.cylinders.length }} cilinder{{ form.cylinders.length > 1 ? 's' : '' }}.</strong
                    >
                </div>
            </div>
        </template>

        <template v-slot:option>
            <div class="flex flex-wrap py-4">
                <extra-keys
                    v-model:keyQty="form.keys.qty"
                    v-model:keysSelected="form.keysSelected"
                    v-model:caps="form.keys.colors"
                    v-model:customColors="form.keys.customColors"
                    :default_qty="data.totals ? data.totals.default_key_qty : 0"
                    :product="product"
                />
            </div>
            <div class="flex flex-wrap" v-if="!predefined.rimlock && !predefined.padlock && product.id != 28">
                <transition name="pop">
                    <Locks
                        :form="form"
                        :product="product"
                        :options="options"
                        @showModalSmartlock="showModalSmartlock(false)"
                        :smartlocks="true"
                        v-if="
                            form.keysSelected &&
                            ((options.padlocks && options.padlocks.length) ||
                                (options.rimlocks && options.rimlocks.length))
                        "
                    >
                    </Locks>
                </transition>
            </div>
        </template>

        <template v-slot:advice>
            <div class="w-full relative">
                <div class="absolute right-0 bottom-0">
                    <transition name="pop">
                        <Advice class="hidden xl:block" v-if="!form.keys.customColors && form.qtySelected" />
                    </transition>
                </div>
            </div>
        </template>
    </step>

    <!-- Upload -->
    <step
        :step="steps.upload"
        title="Upload certificaat"
        description="Voor het nabestellen hebben wij een kopie of foto van uw cerfiticaat nodig waarbij de code zichtbaar is."
        :active="
            ((form.cylindersValid && form.keysSelected) || (product.reorder_type == 2 && form.keysSelected)) &&
            !form.file
        "
        :done="form.file != false"
        :error="$page.props.errors.upload"
        v-if="product.reorder_type"
    >
        <template v-slot:option>
            <upload-file v-model:file="form.file" />
        </template>
    </step>

    <!-- Modal Smartlock -->
    <modal ref="modalSmartlock" :withoutPadding="true">
        <template v-slot:content>
            <smartlocks
                :options="options.smartlocks"
                :cylinders="form.cylinders"
                :cylinder="data.selectedCylinderForSmartlock"
                :totals="data.totals"
                :product="product"
                @close="closeModalSmartlock"
            />
        </template>
    </modal>
</template>

<script setup>
import { useForm, usePage } from '@inertiajs/vue3';
import { computed, onMounted, reactive, ref, watch } from 'vue';

import Smartlocks from '@/Components/Configuration/Shared/Smartlocks.vue';
const modalSmartlock = ref(null);

import Advice from '@/Blocks/Advice.vue';
import AdviceWide from '@/Blocks/AdviceWide.vue';
import Cylinders from '@/Components/Configuration/Cylinders.vue';
import CylinderQty from '@/Components/Configuration/Legacy/CylinderQty.vue';
import ExtraKeys from '@/Components/Configuration/Legacy/ExtraKeys.vue';
import Locks from '@/Components/Configuration/Legacy/Locks.vue';
import Step from '@/Components/Configuration/Legacy/Step.vue';
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue';
import axios from 'axios';
const inBrowser = typeof window !== 'undefined';
const ab_variant = usePage().props.ab_variant;

let source = axios.CancelToken.source();
// const locksComponent = ref();

const emit = defineEmits(['loading', 'endLoading', 'setImageLoading', 'endImageLoading', 'watcherActivated']);

const props = defineProps({
    product: Object,
    cylinders: Array,
    item: [Object, Boolean],
    filter: [Object, Boolean],
    options: Object,
    predefined: Object,
    text_blocks: Object,
    sizesB: Object,
    keys: [Number, Boolean],
    steps: Object,
});

const disableCylinders = ref(props.product.reorder_type == 1 && (props.predefined.padlock || props.predefined.rimlock));

const data = reactive({
    loading: false,
    watcherActivated: false,
    refreshKey: 0,

    // Cylinder qty props
    cylinderQty: 0,
    cylinderCopy: false,
    sliceIndex: 0,
    totals: false,
    showWizard: false,
    focusIndex: 999,
    selectedCylinderForSmartlock: false,
});

const form = useForm({
    qtySelected: false,
    keysSelected: false,
    cylindersValid: false,
    cylinders: [],
    padlocks: [],
    rimlocks: [],

    product_id: props.product.id,
    keys: {
        qty: Number(props.keys),
        default: 0,
        colors: props.options.color_caps,
        customColors: [1, 4, 7, 11, 31, 32, 80, 81, 211, 205, 154, 155, 156, 157, 158, 159, 160].includes(props.product.id) ? true : false,
    },
    file: false,
    processing: false,
    upsellItems: [],
    upsellIds: [],
});

const shouldDisableKeyOption = computed(() => {
    if (props.product.reorder_type == 2 || disableCylinders.value) {
        return false;
    }

    let count = 0;

    form.cylinders.forEach((cylinder) => {
        if (
            form.cylindersValid &&
            cylinder.a == 10 &&
            cylinder.b >= 32 &&
            cylinder.button &&
            !cylinder.button.value.includes('paniekfunctie') &&
            cylinder.button.value != 'Geen knop' &&
            cylinder.button.value != 'Geen'
        ) {
            count++;
        }
    });

    return count == form.cylinders.length && form.cylindersValid;
});

watch(shouldDisableKeyOption, (newValue) => {
    if (newValue) {
        form.keysSelected = true;
        form.keys.qty = 0;
        form.keys.default = 0;
        form.skipKeyOption = true;
    }
});

function calculate() {
    data.loading = true;
    emit('loading');

    let countCilinders = form.cylinders.length;

    if (source) source.cancel();
    const CancelToken = axios.CancelToken;
    source = CancelToken.source();

    axios
        .post(
            '/configurable/calculate/' + props.product.slug,
            {
                cylinders: form.cylinders,
                padlocks: form.padlocks,
                rimlocks: form.rimlocks,
                key_qty: form.keys.qty,
                upsellItems: form.upsellItems,
                keys: form.keys,
                disable_cylinders: disableCylinders.value,
            },
            {
                cancelToken: source.token,
            }
        )
        .then(function (response) {
            data.totals = response.data;
            form.cylindersValid = response.data.cylinders_valid;

            if (response.data.cylinders_invalid.length && form.qtySelected) {
                setTimeout(() => {
                    if (response.data.cylinders_invalid.length) {
                        data.focusIndex = response.data.cylinders_invalid[0];
                    }
                }, 300);
            } else {
                data.focusIndex = 9999;
            }

            if (props.product.reorder_type != 2) {
                fetchSetImage(data.totals.set_image_data);
            }

            if (form.cylindersValid) {
                form.clearErrors('cylindersValid');
                usePage().props.errors.cylindersValid = false;
            }

            if (!form.keysSelected) {
                form.keys.default = data.totals.default_key_qty;
            } else {
                if (data.totals.default_key_qty > form.keys.qty) {
                    form.keys.qty = data.totals.default_key_qty;
                }
            }

            if (inBrowser) {
                window.mitt?.emit('updateForm', { form: form, totals: data.totals });
            }
        })
        .catch(function (response) {
            if (response.message != 'canceled') {
                // Sentry.captureException(response);
            }
            data.loading = false;
            emit('endLoading');
        })
        .finally(function () {
            data.loading = false;
            emit('endLoading');

            if (countCilinders != form.cylinders.length) {
                data.refreshKey++;
            }
        });
}

function showModalSmartlock(cylinder) {
    data.selectedCylinderForSmartlock = cylinder;
    modalSmartlock.value.open = true;
    let gtmevent = false;

    if (cylinder !== false) {
        gtmevent = 'add_smartlock_from_dropdown';
    } else {
        gtmevent = 'add_smartlock_to_set';
    }

    if (inBrowser) {
        window.dataLayer?.push({ event: gtmevent });

        if (typeof hj !== 'undefined') {
            hj('event', gtmevent);
        }
    }
}

function closeModalSmartlock() {
    modalSmartlock.value.open = false;
}

function fetchSetImage(set_image_data) {
    emit('setImageLoading');
    axios
        .post(
            '/configurable/set_image/' + props.product.slug,
            {
                data: set_image_data,
            },
            {
                cancelToken: source.token,
            }
        )
        .then(function (response) {
            if (inBrowser) {
                window.mitt?.emit('updateSetImage', { image: response.data });
            }
            emit('endImageLoading');
        })
        .catch(function () {
            // Sentry.captureException(error);
        });
}

onMounted(() => {
    if (inBrowser) {
        window.mitt?.on('setUpsellItems', (data) => {
            form.upsellItems = form.upsellItems.concat(data);
            form.upsellIds = form.upsellIds.concat(data);
        });
    }

    data.watcherActivated = false;

    // Created
    // Edit from cart
    if (props.item) {
        data.watcherActivated = true;
        data.cylinderQty = props.cylinders.length;
        form.qtySelected = true;
        form.keysSelected = true;
        form.cylindersValid = true;
        form.cylinders = props.cylinders;
        form.keys = props.item.attributes.keys;
        form.file = props.item.attributes.file;

        if (!props.item.attributes.keys.colors) {
            form.keys.colors = [];
        }
    }

    // From filter
    else if (props.filter) {
        data.watcherActivated = true;
        data.cylinderQty = props.cylinders.length;
        form.qtySelected = true;
        form.keysSelected = Number(props.keys) > 0 ? true : false;
        form.cylinders = props.cylinders;
        form.cylindersValid = true;
    }

    // Reorder keys
    else if (props.product.reorder_type == 2) {
        data.watcherActivated = true;
        form.cylinders = [];
    } else if (disableCylinders.value) {
        form.cylinders = [];
    }

    // Cylinders
    else {
        form.cylinders = [
            {
                a: 0,
                b: 0,
                button: props.options.buttons[props.product.has_smartlock ? 1 : 0],
                panic_function: props.options.panic_function[0],
                color: false,
            },
        ];
    }

    if (props.predefined.qty || props.predefined.version || props.product.button_id) {
        data.watcherActivated = true;
        data.cylinderQty = props.predefined.qty ? parseFloat(props.predefined.qty) : 1;
        form.qtySelected = true;
        form.cylinders = props.cylinders;
        form.cylindersValid = true;
    }


    // Predefined Padlocks or Rimlocks
    if (props.predefined.padlock == true) {
        form.padlocks = props.options.padlocks;
        form.qtySelected = true;
        data.cylinderQty = 1;
    }

    if (props.predefined.rimlock == true) {
        form.rimlocks = props.options.rimlocks;
        form.qtySelected = true;
        data.cylinderQty = 1;
    }

    if ((props.predefined.padlock || props.predefined.rimlock) && props.product.reorder_type == 1) {
        form.qtySelected = true;
    }
});


watch(
    () => data.watcherActivated,
    (newValue) => {
        emit('watcherActivated', true);
    }
);

watch(
    () => data.cylinderQty,
    (newValue) => {
        if (props.product.reorder_type != 1 && !props.item && !props.filter) {
            form.keysSelected = false;
            form.keys.qty = false;
        }

        usePage().props.errors.qtySelected = false;
        form.clearErrors('qtySelected');
        data.focusIndex = 0;
        data.refreshKey++;

        if(inBrowser) {
            dataLayer.push({ 
                event: 'configuration_steps',
                ab_variant: ab_variant,
                step_name: '1. Aantal cilinders',
            });
        }

        if (inBrowser) {
            if (!(props.predefined.padlock || props.predefined.rimlock)) {
                window.mitt.emit('updateShoppingImage', newValue);
            }
        }
    }
);

watch(
    () => form.cylinders,
    () => {
        if (data.watcherActivated) {
            calculate();
        }
    },
    { deep: true }
);
watch(
    () => form.padlocks,
    () => {
        if (data.watcherActivated) {
            calculate();
        }
    },
    { deep: true }
);
watch(
    () => form.rimlocks,
    () => {
        if (data.watcherActivated) {
            calculate();
        }
    },
    { deep: true }
);

watch(
    () => form.keys,
    () => {
        if (form.keysSelected) {
            calculate();
            form.clearErrors('keysSelected');
            usePage().props.errors.keysSelected = false;
        }
    },
    { deep: true }
);

watch(
    () => disableCylinders,
    (newValue) => {
        if (newValue.value) {
            form.cylindersValid = true;
            form.qtySelected = true;
            form.cylinders = [];
            form.keys.qty = 0;
        } else {
            form.cylinders = props.cylinders;
        }
        calculate();
    },
    { deep: true }
);

watch(
    () => form.qtySelected,
    (newValue) => {
        if (newValue) {
            data.watcherActivated = true;
            calculate()
        }
    }
);

watch(
    () => form.keysSelected,
    (newValue) => {
        if (newValue) {
            data.watcherActivated = true;
        }
    }
);

watch(
    () => form.cylindersValid,
    (newValue) => {
        if (newValue) {
            data.watcherActivated = true;
        }
    }
);

watch(
    () => form.file,
    (newValue) => {
        if (newValue) {
            data.watcherActivated = true;
        }
    }
);

watch(
    () => form.padlocks,
    (newValue) => {
        if (newValue && newValue.length > 0) {
            data.watcherActivated = true;
        }
    },
    { deep: true }
);

watch(
    () => form.rimlocks,
    (newValue) => {
        if (newValue && newValue.length > 0) {
            data.watcherActivated = true;
        }
    },
    { deep: true }
);

watch(
    () => form.keys.qty,
    (newValue) => {
        if (newValue > 0) {
            data.watcherActivated = true;
        }
    }
);

watch(
    () => form.keys.colors,
    (newValue) => {
        if (newValue && newValue.length > 0) {
            data.watcherActivated = true;
        }
    },
    { deep: true }
);
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>